<template>
  <div>
    <div id="overlay" @click="$emit('close-form')"></div>
    <div id="form">
      <div class="row details-area p-2">
        <div class="col-xs-12">
          <h5 class="center">Escolha um modelo</h5>
          <b-button
            v-for="model in models"
            :key="model.ID"
            @click="pickModel(model)"
            variant="3v3"
            size="sm"
            block
            >{{ model.NAME }}</b-button
          >
        </div>
      </div>
      <footer id="footer">

        <b-btn size="sm" block @click="$emit('close-form')"> Fechar </b-btn>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: "show-models",
  data() {
    return {
      pickedModel: {},
    };
  },
  props: {
    showForm: Boolean,
    formType: String,
    equipment: String,
    models: Array,
    typeDropDown: String,
    // alreadyUsedAddrs: [String, Array],
    oldAddr: [Boolean, Number],
    oldModelName: [Boolean, String],
    itemToEdit: [Boolean, Number, Object],
    emrsensors: Array,
    valves: Array,
    pumps: Array,
    modbusPumps: Array,
    hydros: Array,
    pulses: Array,
    sensors: Array,
    onoffs: Array,
    modbusSensors: Array,
    sensorsi2c: Array,
    sensorssdi: Array,
  },
  created() {
    this.regexMTD = new RegExp("MTD");
  },
  methods: {
    pickModel(model) {
      // monta a quantidade de campos

      this.pickedModel = model;
      this.$emit("model-name", model);

      this.step = 2;
    },
  },
};
</script>

<style scoped>
.btn {
  margin-bottom: 5px;
}
.separator {
  margin: 0 5px;
}
@media screen and (max-width: 768px) {
  #form, #details {
    padding-top: 1em;
}
}
</style>
